import type { Theme } from '@repo/ui/components/theme-provider'

export const themeConfig: { defaultTheme: Theme } = {
  defaultTheme: 'system',
}
